import styled from '@emotion/styled';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import specialtyIconUrl from 'src/public/img/icon_coaching_specialty.svg';
import { Modal } from 'src/shared/components/Modal';
import { color, font } from 'src/shared/styles/variables';
import { IntakeFormTestID } from '../models/intakeForm';
import { CoachIntroWrapper } from './CoachIntroWrapper';

interface Props {
    coachIntroduction: string;
    coachAvatar: string;
    coachCredentials: string;
    coachSpecialties: string[];
    coachFirstName: string;
    coachLastName: string;
    userFirstName: string;
    closeCoachMoreInfoModal: () => void;
}

interface CoachParaProps {
    icon?: boolean;
}

const ModalBodyWrapper = styled('div')({
    padding: 32,
});

const CoachPara = styled('p')<CoachParaProps>(
    ({ icon }) => ({
        ':first-of-type': { marginTop: 24 },
        ...(icon
            ? {
                  display: 'flex',
              }
            : {}),
        marginBottom: 16,
        lineHeight: '24px',
        color: color.blueBayoux,
    }),
    font.medium(font.size.medium),
);

const StyledSpan = styled('span')(
    {
        lineHeight: '24px',
        color: color.royalBlue,
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    font.medium(font.size.medium),
);

const SpecialtyIcon = styled('div')({
    height: 24,
    width: 24,
    backgroundImage: `url(${specialtyIconUrl})`,
    marginRight: 24,
});

export const CoachMoreInfoModal: React.FC<Props> = ({
    coachCredentials,
    coachAvatar,
    coachIntroduction,
    coachSpecialties,
    coachFirstName,
    coachLastName,
    userFirstName,
    closeCoachMoreInfoModal,
}) => {
    const coachIntroSplit = (coachIntroduction || '').split(' ');
    const [expanded, setExpanded] = useState(coachIntroSplit.length <= 25);
    const { t } = useTranslation();
    const truncatedIntro = coachIntroSplit.slice(0, 25).join(' ');

    return (
        <Modal visible footer={null} width={640} onCancel={closeCoachMoreInfoModal}>
            <ModalBodyWrapper data-testid={IntakeFormTestID.CoachMoreInfoModal}>
                <CoachIntroWrapper
                    header={0}
                    coachAvatar={coachAvatar}
                    coachCredentials={coachCredentials}
                    coachFirstName={coachFirstName}
                    coachLastName={coachLastName}
                />
                <CoachPara>{t('intakeForms:coach_info.greeting', { userFirstName })}</CoachPara>
                <CoachPara icon>
                    <SpecialtyIcon /> {coachSpecialties.join(', ')}
                </CoachPara>
                {!expanded && (
                    <CoachPara>
                        {truncatedIntro} ...
                        <StyledSpan role="button" onClick={() => setExpanded(true)}>
                            {t('intakeForms:coach_info.read_more')}
                        </StyledSpan>
                    </CoachPara>
                )}
                {expanded && <CoachPara>{coachIntroduction}</CoachPara>}
            </ModalBodyWrapper>
        </Modal>
    );
};
